/* eslint-disable */
export default {
  loginButton: 'Sign In',
  signupButton: 'New user? Sign Up',
  version: 'Version',
} as const;

// @key: @#@"loginButton"@#@ @source: @#@"Sign In"@#@
// @key: @#@"signupButton"@#@ @source: @#@"New user? Sign Up"@#@
// @key: @#@"version"@#@ @source: @#@"Version"@#@
